import { emailcontacts } from "../../config/emailcontacts";

const EmailBlock = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-12 overflow-hidden">
      {emailcontacts.map((items: any, index) => (
        <a key={index} className="w-full" href={items.link}>
          <div className="w-full flex items-center border-[3px] border-line hover:border-primary_light hover:cursor-pointer transition duration-500 px-4 pl-2 py-2 rounded-lg">
            <div>
              <h2 className="font-semibold text-[16px]">{items.title}</h2>
              <div className="flex flex-col pt-2">
                <span className="text-[12px] text-wrap">{items.name}</span>
                <span className="text-text_light text-[12px] text-wrap">{items.email}</span>
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default EmailBlock;
